exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\n    cursor: pointer;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/shared/layout/header-inicial/header-inicial.component.css
// module id = ../../../../../src/app/area-restrita/shared/layout/header-inicial/header-inicial.component.css
// module chunks = main